import * as React from 'react';
import type { UpdateServiceOrderPayload } from 'contracts/service-orders';
import { api } from 'services/api';

type Params = {
  serviceOrderId: number;
  payload: UpdateServiceOrderPayload;
}

export const useUpdateServiceOrder = () => {
  const updateServiceOrder = React.useCallback(async (params: Params) => {
    const url = `/inventory/service-orders/${params.serviceOrderId}`;
    await api.put(url, params.payload);
  }, []);

  return {
    updateServiceOrder,
  };
};